// =========================================================
// * Vuetify Material Dashboard - v2.1.0
// =========================================================
//
// * Product Page: https://www.creative-tim.com/product/vuetify-material-dashboard
// * Copyright 2019 Creative Tim (https://www.creative-tim.com)
//
// * Coded by Creative Tim
//
// =========================================================
//
// * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/base'
import './plugins/chartist'
import './plugins/vee-validate'
import vuetify from './plugins/vuetify'
import i18n from './i18n'
import JsonExcel from 'vue-json-excel'
import VueMask from 'v-mask'
import ApexCharts from 'apexcharts'

Vue.config.productionTip = false
Vue.use(VueMask);

Vue.component('downloadExcel', JsonExcel)


router.beforeEach((to, from, next) => {
 
 
  if(to.path != '/login' && to.path != '/cadastro'){
    const user = JSON.parse(sessionStorage.getItem('user'))

    if(user == null){
      router.push('login');
    }

    if(to.path == '/upload'){
      if(!user.roles.includes('ROLE_ADMIN') && !user.roles.includes('ROLE_DOC_UPLOAD')){
        router.push('restrito');
      }
    }

    if(to.path == '/historico'){
      if(!user.roles.includes('ROLE_ADMIN') && !user.roles.includes('ROLE_LIST_HIST')){
        router.push('restrito');
      }
    }

    if(to.path == '/usuario'){
      if(!user.roles.includes('ROLE_ADMIN') && !user.roles.includes('ROLE_USER')){
        router.push('restrito');
      }
    }

    if(to.path == '/dashboard'){
      if(!user.roles.includes('ROLE_ADMIN') && !user.roles.includes('ROLE_DOC_LISTA')){
        router.push('restrito');
      }
    }

 
}
  
      next()
}),



new Vue({
  router,
  store,
  vuetify,
  i18n,
  components:{ ApexCharts },
  render: h => h(App),
}).$mount('#app')
